export default {
  0: 'All',
  1: 'Portfolios',
  2: 'Sets',
  3: 'Holdings',
  4: 'Other',
  5: 'Instruments',
  9: 'Peer Groups'
};
